export default "__VITE_ASSET__DSCiJtCf__"